export default __webpack_public_path__ + "static/media/lightbulb.d9a5ed1a.svg";